import { type ReactNode, type Ref } from 'react';

interface ContentBodyProps {
  children?: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}

const ContentBody = ({ children = undefined, className = '', ref }: ContentBodyProps) => (
  <div ref={ref} className={`content__body ${className}`} data-testid="content-body">
    {children}
  </div>
);

export default ContentBody;
